import React, { ReactElement, useState } from 'react';

// Components
import useColorToolState from '../hooks/useColorToolState';
import ColorPopupContent from '../ColorPopupContent';
import CustomColorInput from '../../CustomColorInput';
import SheetContainer, { Content, Overlay, Sheet } from '../../../../../../../mobile/structural/sheet';

// Selectors
import { ColorToolSelectorReturnType } from '../../colorToolSelector';

// Types
import { ImMNElement } from '../../../../../../../../common/elements/elementModelTypes';
import { UseSheetReturnType } from '../../../../../../../mobile/structural/sheet/hooks/useSheet';

import './MobileColorToolContent.scss';

// Constants
import { Color } from '../../../../../../../../common/colors/colorConstants';

const MOBILE_MAX_SUGGESTED_COLORS = 7;

type MobileColorToolContentProps = ColorToolSelectorReturnType & {
    customDefaultColors?: Color[];
    customColorHandler?: (color: string | null, secondaryColor?: string | null | undefined) => void;
    customTempColorHandler?: (color: string | null, secondaryColor?: string | null | undefined) => void;
    selectedElements: Immutable.List<ImMNElement>;
    dispatchOpenSheet: () => void;
    dispatchCloseSheet: () => void;
    sheetProps: UseSheetReturnType;
};

const MobileColorToolContent = (props: MobileColorToolContentProps): ReactElement => {
    const { customDefaultColors, dispatchOpenSheet, dispatchCloseSheet, sheetProps } = props;
    const { isSheetOpen } = sheetProps;

    const {
        popupColor,
        popupColorHex,
        supportColorBar,
        openCustomColorPicker,
        actualPopupMode,
        setColorPopupMode,
        supportDualColors,
        defaultColors,
        customColorInputRef,
        setColor,
        setTempColor,
        suggestedColors,
    } = useColorToolState({ ...props, isPopupOpen: isSheetOpen });

    const [isCustomPickerOpen, setIsCustomPickerOpen] = useState(false);

    const onCustomInputBlur = () => {
        dispatchOpenSheet();
        setIsCustomPickerOpen(false);
    };

    const onCustomInputFocus = () => {
        dispatchCloseSheet();
        setIsCustomPickerOpen(true);
    };

    const showCustomColorPickerInput = isSheetOpen || isCustomPickerOpen;

    return (
        <>
            <SheetContainer {...sheetProps} className="color-tool">
                <Overlay />
                <Sheet>
                    <Content>
                        <ColorPopupContent
                            {...props}
                            defaultColors={customDefaultColors || defaultColors}
                            supportColorBar={supportColorBar}
                            setColor={setColor}
                            selectedColor={popupColor}
                            selectedColorHex={popupColorHex}
                            openCustomColorPicker={openCustomColorPicker}
                            colorPopupMode={actualPopupMode}
                            setColorPopupMode={setColorPopupMode}
                            supportDualColors={supportDualColors}
                            suggestedColors={suggestedColors}
                            maxSuggestedColors={MOBILE_MAX_SUGGESTED_COLORS}
                        />
                    </Content>
                </Sheet>
            </SheetContainer>
            {showCustomColorPickerInput && (
                <CustomColorInput
                    className="custom-color-picker-input"
                    ref={customColorInputRef}
                    initialColor={popupColorHex}
                    setTempColor={setTempColor}
                    setColor={setColor}
                    onBlur={onCustomInputBlur}
                    onFocus={onCustomInputFocus}
                />
            )}
        </>
    );
};

export default MobileColorToolContent;
